(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chaussia-featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSection(section) {
    var tabs = section.querySelectorAll('[data-tab-target]');
    var grid = section.querySelector('[data-grid]');
    var cards = section.querySelectorAll('[data-collection-handle]');
    var prevBtn = section.querySelector('.chaussia-fproducts__arrow--prev');
    var nextBtn = section.querySelector('.chaussia-fproducts__arrow--next');

    // Tab filtering
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.dataset.tabTarget;
        tabs.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
        cards.forEach(function(card) {
          if (target === 'all' || card.dataset.collectionHandle === target) {
            card.classList.remove('is-hidden');
          } else {
            card.classList.add('is-hidden');
          }
        });
        if (grid) grid.scrollLeft = 0;
      });
    });

    // Arrow navigation
    function getScrollAmount() {
      var visibleCard = grid && grid.querySelector('.chaussia-fproduct-card:not(.is-hidden)');
      if (!visibleCard || !grid) return 300;
      var style = window.getComputedStyle(grid);
      var gap = parseFloat(style.gap) || 16;
      return visibleCard.offsetWidth + gap;
    }

    if (prevBtn && grid) {
      prevBtn.addEventListener('click', function() {
        grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn && grid) {
      nextBtn.addEventListener('click', function() {
        grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }
  }

  function init() {
    document.querySelectorAll('.chaussia-fproducts').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chaussia-testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSection(section) {
    var slider = section.querySelector('[data-slider]');
    if (!slider) return;

    var cards = section.querySelectorAll('.chaussia-testimonial-card');
    var dots = section.querySelectorAll('[data-dot-index]');
    var prevBtn = section.querySelector('.chaussia-testimonials__arrow--prev');
    var nextBtn = section.querySelector('.chaussia-testimonials__arrow--next');

    function getScrollAmount() {
      var card = cards[0];
      if (!card) return 300;
      var style = window.getComputedStyle(slider);
      var gap = parseFloat(style.gap) || 16;
      return card.offsetWidth + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        slider.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        slider.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    // Click a dot → scroll to that card
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(this.dataset.dotIndex, 10);
        var card = cards[index];
        if (!card) return;
        slider.scrollTo({ left: card.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      });
    });

    // Active dot follows scroll position
    function setActiveDot(index) {
      dots.forEach(function(d, i) {
        if (i === index) {
          d.classList.add('is-active');
        } else {
          d.classList.remove('is-active');
        }
      });
    }

    if ('IntersectionObserver' in window && dots.length) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            var index = Array.prototype.indexOf.call(cards, entry.target);
            if (index >= 0) setActiveDot(index);
          }
        });
      }, {
        root: slider,
        threshold: [0.55, 0.75]
      });
      cards.forEach(function(card) { observer.observe(card); });
    }
  }

  function init() {
    document.querySelectorAll('.chaussia-testimonials').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
